<template>
  <v-app>
    <section class="product">
      <div class="product_page page-bottom" key="product_page">
        <SubTitle
          :TitleName="'http://d-mebius.com/miasmabreaker/assets/index_products.png'"
          :AltText="'商品情報'"
        />

        <SoftProduct />
      </div>
    </section>
  </v-app>
</template>

<script>
  import SoftProduct from "./SoftProduct.vue"; // 正しいインポートを追加
  import SubTitle from "./SubTitle.vue";

  export default {
    components: {
      SoftProduct,
      SubTitle,
    },
  };
</script>

<style scoped>
  .product_page {
    padding: 0px;
  }
  h1 {
    font-size: 2em;
    margin-bottom: 10px;
  }
  h2 {
    font-size: 1.5em;
    margin-bottom: 20px;
  }
</style>
